import axios from 'common/interceptor/app.interceptor';
import appConfig from 'config/config';

import { isApiSuccess } from '../utils';

const useService = (baseURL = '') => {
  let axiosInstance = '';

  if (baseURL) {
    axiosInstance = axios.create({
      baseURL: baseURL
    });
  } else {
    axiosInstance = axios.create({
      baseURL: appConfig.pnqapiBaseUrl
    });
  }

  const _get = (url = '', config = {}) => {
    return axiosInstance.get(url, config);
  };

  const _post = (url = '', data = {}, config = {}) => {
    return axiosInstance.post(url, data, config);
  };

  const _patch = (url = '', data = {}, config = {}) => {
    return axiosInstance.patch(url, data, config);
  };

  const _delete = (url = '', config = {}) => {
    return axiosInstance.delete(url, config);
  };

  return {
    _get,
    _post,
    _patch,
    _delete,
    isApiSuccess
  };
};

export default useService;
